import React from 'react';
import Seo from '../../components/Seo';
import LegalPageLayout from './LegalPageLayout';
import { resetCookieConsent } from '../../components/CookieConsent';

export default function CookiePolicy() {
  return (
    <LegalPageLayout title="Cookie Policy" lastUpdated="10 June 2026">
      <Seo
        title="Cookie Policy"
        description="How Atlas Academy uses cookies and similar technologies, and how you can manage your preferences."
        path="/cookie-policy"
      />
      <div>
        <h2>1. What are cookies?</h2>
        <p>
          Cookies are small text files placed on your device when you visit a website. They help websites
          remember your preferences and understand how the site is used. Similar technologies such as local
          storage work in the same way, and this policy covers those too.
        </p>
      </div>
      <div>
        <h2>2. Cookies we use</h2>
        <ul>
          <li>
            <strong>Strictly necessary</strong> — used to remember essential choices, such as your language
            preference and your cookie consent decision. These do not require consent and cannot be switched off.
          </li>
          <li>
            <strong>Analytics (optional)</strong> — we use PostHog to understand how visitors use our site so
            we can improve it. These cookies are set <em>only if you accept them</em> in our cookie banner.
            They collect information such as pages visited and interactions on the site.
          </li>
        </ul>
      </div>
      <div>
        <h2>3. Managing your preferences</h2>
        <p>
          You can change your mind at any time. Click the button below to clear your saved choice — the
          cookie banner will appear again on your next page view.
        </p>
        <button
          onClick={() => {
            resetCookieConsent();
            window.location.reload();
          }}
          className="mt-2 bg-[#0f2b4a] hover:bg-[#1565c0] text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors"
        >
          Reset cookie preferences
        </button>
        <p className="mt-4">
          You can also block or delete cookies through your browser settings. Note that blocking strictly
          necessary cookies may affect how the site works.
        </p>
      </div>
      <div>
        <h2>4. More information</h2>
        <p>
          For details on how we handle personal data, see our <a href="/privacy-policy">Privacy Policy</a>.
          Questions? Email <a href="mailto:info@atlas-academy.co.uk">info@atlas-academy.co.uk</a>.
        </p>
      </div>
    </LegalPageLayout>
  );
}
